// Voices: LinkedIn authors tagged by the audience they draw, offered in the
// Add Contacts modal so a list can be filled by category.
export const createGetVoiceCategoriesRequest = () => {
  return {
    url: "/voices/categories",
    method: "GET",
    disableLoading: true,
  };
};

export const createSearchVoicesRequest = (category, q, page = 1, per_page = 50) => {
  return {
    url: "/voices",
    method: "GET",
    params: { category, q, page, per_page },
    disableLoading: true,
  };
};
